import { render, staticRenderFns } from "./forgotten_pass.vue?vue&type=template&id=1b732e2c&scoped=true"
import script from "./forgotten_pass.vue?vue&type=script&lang=js"
export * from "./forgotten_pass.vue?vue&type=script&lang=js"
import style0 from "./forgotten_pass.vue?vue&type=style&index=0&id=1b732e2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b732e2c",
  null
  
)

export default component.exports